import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { Loading } from 'components/shared/Loading';
import { Typography } from 'components/shared/Typography';

import styles from './CuratorReportLoading.module.scss';

const CuratorReportLoading = ({
  className,
  titleKey,
  subtitleKey,
  variant = 'page',
}: {
  className?: string;
  titleKey: string;
  subtitleKey: string;
  variant?: 'page' | 'section';
}) => (
  <div
    className={cn(
      styles.wrapper,
      variant === 'section' && styles.wrapperSection,
      className,
    )}
  >
    <div
      className={cn(styles.card, variant === 'section' && styles.cardSection)}
    >
      <div className={styles.spinnerWrap}>
        <Loading size={32} variant="centered" />
      </div>
      <Typography
        className={styles.title}
        variant="body1"
        weight="medium"
        mode="compact"
      >
        {getTranslation(titleKey)}
      </Typography>
      <Typography className={styles.subtitle} variant="body3" mode="compact">
        {getTranslation(subtitleKey)}
      </Typography>
    </div>
  </div>
);

export default React.memo(CuratorReportLoading);
